import './CheckoutTerms.scss';
import React from 'react';
import Link from 'components/UI/Link';
import { useSelector } from 'react-redux';
function CheckoutTerms() {
    const isB2BModeEnabled = useSelector((state) => state.ui.isB2BModeEnabled);
    return (React.createElement("div", { className: "checkout-terms" },
        React.createElement("div", { className: "checkout-terms__label" },
            !isB2BModeEnabled && React.createElement("img", { alt: 'Betal med Visa, Mastercard eller Vipps i Dintero', src: "https://backoffice.dintero.com/checkouts/v1/branding/profiles/P11114875.5z4eM6ZHNZJsTg7c4poGuj/variant/colors/width/420/dintero_top_frame.svg" }),
            React.createElement("br", null),
            React.createElement("br", null),
            "Ved \u00E5 fullf\u00F8re godtar du",
            ' ',
            React.createElement(Link, { to: "/informasjon/personvern" }, "personvern og avtalevilk\u00E5rene v\u00E5re"),
            ".")));
}
export default CheckoutTerms;
